import { render, staticRenderFns } from "./RendJournalPlotTrade.vue?vue&type=template&id=563ed9f6&"
import script from "./RendJournalPlotTrade.vue?vue&type=script&lang=js&"
export * from "./RendJournalPlotTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports